import { combineReducers } from 'redux';

import {
  ACTION_LOAD_CHART_DATA__REQUEST,
  ACTION_LOAD_CHART_DATA__SUCCESS,
} from '../actionTypes';

import error from './error';


const data = (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_CHART_DATA__REQUEST:
      return null;

    case ACTION_LOAD_CHART_DATA__SUCCESS:
      return {
        series: action.payload.series,
        timeGrouping: action.payload.timeGrouping,
      };

    default:
      return state;
  }
};

export default combineReducers({
  data,
  error,
});
